export const INTRO_INDEX = 0;
export const SPEED_INDEX = 1;
export const STORY_INDEX = 2;

export const BACKGROUND_IMAGE_SRC =
  'https://assets.isuzu-tis.com/bg_engine_backdrop_62a64205d0.jpg';

export const BACKGROUND_IMAGE_FALLBACK_SRC =
  'https://assets.isuzu-tis.com/fallback_3_bg_desktop_e0406dc98b.jpg';

export const SPARTAN_ENGINE_SECTION_IDS = [
  'intro',
  'acceleration',
  'story',
] as const;

export const SPARTAN_ENGINE_SECTION_COUNT = SPARTAN_ENGINE_SECTION_IDS.length;
